var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1500,
    height: 647,
    viewBox: "0 0 1500 647",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1504 219.601V667.843L1190.54 669V666.795L599.121 669V666.851L32.6144 669H-16V292.857H32.5042V209.073H129.292V280.179H158.836V148.716H165.284V139.511H166.442V148.716H189.757V139.511H190.914V148.716H223.985V139.511H225.143V148.716H245.923V139.511H247.08V148.716H255.623V271.415H288.309V251.571L326.836 251.737V219.546H334.608V213.207H335.655V219.546H365.419H371.372V213.152H372.419V219.546H379.585V283.486H425.443V307.023H450.963V293.353H474.554V239.114H486.349V213.869H488.113V239.169H516.389V191.71H519.144V239.169H537.83V238.508V232.499V226.822V217.341V211.278V201.797V195.734V186.253V179.694V170.213V161.89V152.409V146.125H543.397V139.015H544.279V146.125H585.562V139.015H586.444V146.125H593.995V195.734L599.287 195.789V195.734H599.232V186.253H599.287V179.694H599.232V170.213H599.287V163.709H599.232V154.228H599.287H649.334H657.933C658.374 154.504 658.814 154.724 659.255 155V209.128H695.854V280.234H725.398V148.716H731.846V139.511H733.004V148.716H756.319V139.511H757.476V148.716H790.547V139.511H791.705V148.716H812.485V139.511H813.642V148.716H822.185V271.415H854.871V251.571L893.398 251.737V219.546H901.17V213.207H902.217V219.546H931.981H937.934V213.152H938.981V219.546H946.147V283.486H992.005V307.023H1017.53V293.353H1041.17V239.114H1052.97V213.869H1054.73V239.169H1083.01V191.71H1085.76V239.169H1104.45V238.508H1104.39V232.499H1104.45V226.822H1104.39V217.341H1104.45V211.278H1104.39V201.797H1104.45V195.734H1104.39V186.253H1104.45V179.694H1104.39V170.213H1104.45V161.89H1104.39V152.409H1104.45V146.125H1110.01V139.015H1110.9V146.125H1152.18V139.015H1153.06V146.125H1160.61V195.734L1165.9 195.789V195.734H1165.85V186.253H1165.9V179.694H1165.85V170.213H1165.9V163.709H1165.85V154.228H1165.9H1215.95H1224.55C1224.99 154.504 1225.43 154.724 1225.87 155V209.128H1287.27V280.234H1316.82V148.716H1323.27V139.511H1324.42V148.716H1347.74V139.511H1348.9V148.716H1381.97V139.511H1383.13V148.716H1413.61V271.415H1446.29V251.571L1484.82 251.737V219.546H1492.59V213.207H1493.64V219.546H1504V219.601Z",
    fill: "#D5E5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.241 148.716H748.383V169.496H822.241V148.716Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.241 180.741H748.383V201.522H822.241V180.741Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.241 213.428H748.383V234.208H822.241V213.428Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.241 246.61H748.383V267.391H822.241V246.61Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.241 278.69H748.383V299.471H822.241V278.69Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1139.01 146.125H1104.56V158.748H1139.01V146.125Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1139.01 165.583H1104.56V178.206H1139.01V165.583Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1139.01 185.426H1104.56V198.048H1139.01V185.426Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1139.01 205.6H1104.56V218.222H1139.01V205.6Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1139.01 225.058H1104.56V237.68H1139.01V225.058Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1139.01 246.444H1104.56V259.067H1139.01V246.444Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1139.01 265.902H1104.56V278.525H1139.01V265.902Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1139.01 285.745H1104.56V298.368H1139.01V285.745Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1139.01 305.92H1104.56V318.543H1139.01V305.92Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1139.01 325.377H1104.56V338H1139.01V325.377Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.78 154.394H1165.85V167.016H1202.78V154.394Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.78 173.852H1165.85V186.474H1202.78V173.852Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.78 193.694H1165.85V206.317H1202.78V193.694Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.78 213.869H1165.85V226.492H1202.78V213.869Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.78 233.326H1165.85V245.949H1202.78V233.326Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.78 253.61H1165.85V266.233H1202.78V253.61Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.78 273.068H1165.85V285.691H1202.78V273.068Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.78 292.911H1165.85V305.534H1202.78V292.911Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.78 313.085H1165.85V325.708H1202.78V313.085Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.78 332.543H1165.85V345.166H1202.78V332.543Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.78 354.812H1165.85V367.435H1202.78V354.812Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.78 374.271H1165.85V386.893H1202.78V374.271Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.78 394.113H1165.85V406.736H1202.78V394.113Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.78 414.287H1165.85V426.91H1202.78V414.287Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.78 433.745H1165.85V446.368H1202.78V433.745Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1413.66 148.716H1346.42V169.496H1413.66V148.716Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1413.66 180.741H1346.42V201.522H1413.66V180.741Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1413.66 213.428H1346.42V234.208H1413.66V213.428Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1413.66 246.61H1346.42V267.391H1413.66V246.61Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1413.66 278.69H1346.42V299.471H1413.66V278.69Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.71 148.716H158.891V169.496H230.71V148.716Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.71 180.079H158.891V200.86H230.71V180.079Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.71 212.766H158.891V233.546H230.71V212.766Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.71 245.948H158.891V266.729H230.71V245.948Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.71 277.974H158.891V298.754H230.71V277.974Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.429 146.125H537.5V158.748H574.429V146.125Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.429 165.583H537.5V178.206H574.429V165.583Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.429 185.426H537.5V198.048H574.429V185.426Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.429 205.6H537.5V218.222H574.429V205.6Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.429 225.058H537.5V237.68H574.429V225.058Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.429 246.444H537.5V259.067H574.429V246.444Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.429 265.902H537.5V278.525H574.429V265.902Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.429 285.745H537.5V298.368H574.429V285.745Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.429 305.92H537.5V318.543H574.429V305.92Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.429 325.377H537.5V338H574.429V325.377Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.004 154.394H600.059V167.016H642.004V154.394Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.004 173.852H600.059V186.474H642.004V173.852Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.004 193.694H600.059V206.317H642.004V193.694Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.004 213.869H600.059V226.492H642.004V213.869Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.004 233.326H600.059V245.949H642.004V233.326Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.004 253.61H600.059V266.233H642.004V253.61Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.004 273.068H600.059V285.691H642.004V273.068Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.004 292.911H600.059V305.534H642.004V292.911Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.004 313.085H600.059V325.708H642.004V313.085Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.004 332.543H600.059V345.166H642.004V332.543Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.004 354.812H600.059V367.435H642.004V354.812Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.004 374.271H600.059V386.893H642.004V374.271Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.004 394.113H600.059V406.736H642.004V394.113Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.004 414.287H600.059V426.91H642.004V414.287Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.004 433.745H600.059V446.368H642.004V433.745Z",
    fill: "#E2EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.091 29.214C646.158 29.214 652.697 22.6742 652.697 14.607C652.697 6.53977 646.158 0 638.091 0C630.024 0 623.484 6.53977 623.484 14.607C623.484 22.6742 630.024 29.214 638.091 29.214Z",
    fill: "#F8FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1504 554.184H-16V644.857H1504V554.184Z",
    fill: "#9DB0F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1504 644.803H-16V656.378H1504V644.803Z",
    fill: "#D5E5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.242 554.183C626.242 554.183 631.368 510.693 592.344 501.653C553.376 492.613 574.155 466.486 544.667 452.706C515.234 438.926 472.737 444.713 462.375 477.345C451.958 509.976 419.934 480.266 380.91 477.345C341.886 474.423 331.138 494.928 324.414 505.897C317.689 516.866 263.949 523.426 238.815 493.716C213.681 464.006 195.492 457.446 167.767 457.281C140.043 457.116 131.279 416.271 90.6016 415.444V552.86L626.242 554.183Z",
    fill: "#C2D9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16 401.003C-16 401.003 63.4807 375.317 112.316 401.003C161.151 426.689 153.048 464.888 200.119 454.139C247.245 443.391 325.624 483.794 296.08 554.845C296.08 554.845 -16 553.853 -16 554.845C-16 555.892 -16 401.003 -16 401.003Z",
    fill: "#ACCCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.31 554.183C729.31 554.183 721.925 489.637 778.311 476.298C834.697 462.903 804.602 424.153 847.209 403.704C889.815 383.254 951.217 391.853 966.264 440.249C981.312 488.645 1027.67 444.548 1084.05 440.249C1140.44 435.949 1156.04 466.321 1165.79 482.636C1175.55 498.897 1253.27 508.653 1289.59 464.612C1325.91 420.515 1352.26 410.814 1392.33 410.539C1432.46 410.263 1445.13 349.685 1503.94 348.473V552.254L1324.92 585.933L1228.3 552.805L729.31 554.183Z",
    fill: "#ACCCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.23 645C942.23 645 936.886 582.542 977.73 569.643C1018.64 556.659 996.816 519.235 1027.74 499.463C1058.66 479.69 1103.19 488.006 1114.07 534.765C1124.95 581.524 1158.6 538.923 1199.51 534.765C1240.42 530.607 1251.68 559.969 1258.81 575.753C1265.93 591.537 1322.24 600.957 1348.57 558.272C1374.91 515.671 1394 506.252 1423.07 505.997C1452.15 505.742 1461.37 447.103 1504 446V643.133L942.23 645Z",
    fill: "#6DA6FF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundLogin);
export default __webpack_public_path__ + "static/media/background-login.722138c714819701f2ab856e8eb91a88.svg";
export { ForwardRef as ReactComponent };